import loader from "../images/loader.gif"
const LoaderComponent = () => {
    return (
        <div className="loader-container" style={{display: "flex", justifyContent:"center", alignItems: "center"}}>
            <img src={loader} style={{width: "60px"}}/>
        </div>
    )
}

export default LoaderComponent;